import Vue from "vue";
import moment from "moment";
import { TipoPedidoEnum } from '@/models/sit-pedido/tipo-pedido.enum';
import { StatusPedidoEnum } from '@/models/sit-pedido/status-pedido.enum';
import { formatCpfCnpjDisplay } from '@/helpers/cpf-cnpj-display';

/**
 * Filtro de data, modifica o formato da data para o padrão de data Brasil
 * Ex.: 1994-02-11 para 11/02/1994
 */
const date = Vue.filter("date", (value: any) => {
  if (!value) return null;

  return moment(value, "YYYY-MM-DD").format("DD/MM/YYYY");
});

/**
 * Filtro de cpf, modifica o valor numerico passado para o padrão de cpf do Brasil
 * Ex.: 00000000000 para 000.000.000-00
 */
const cpf = Vue.filter("cpf", (value: any) => {
  if (!value) return null;

  let cpf = value.padStart(11, "0");
  cpf = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

  return cpf;
});

/**
 * Filtro de cnpj, modifica o valor passado para o padrão de cnpj do Brasil (numérico ou alfanumérico)
 * Ex.: 00000000000000 para 00.000.000/0000-00 e 12ABC34501DE35 para 12.ABC.345/01DE-35
 */
const cnpj = Vue.filter("cnpj", (value: any) => {
  if (!value) return null;

  return formatCpfCnpjDisplay(value);
});

/**
 * Filtro de sexo, retorna masculino ou Feminino, de acordo com o valor numérico atribuido
 * Ex.: 1 para Masculino ou 2 para Feminino
 */
const sexo = Vue.filter("sexo", (value: any) => {
  if (!value) return null;

  return parseInt(value) === 1 ? "Masculino" : "Feminino";
});

/**
 * Filtro de tipo de pedido
 */
const tipoPedido = Vue.filter("tipoPedido", (value: any) => {
  if (!value) return null;

  return TipoPedidoEnum[value]
});

/**
 * Filtro de status de pedido
 */
const statusPedido = Vue.filter("statusPedido", (value: any) => {
  if (!value) return null;

  return StatusPedidoEnum[value]
});

export default { date, cpf, cnpj, sexo, tipoPedido, statusPedido };
